export default __webpack_public_path__ + "static/media/Reports_Hover.e012105c.png";